import './CommonPage.scss';
import React from "react";
import CustomRouterComp from "../../CommonUtils/CustomRouterComp";
import {useRecoilValue} from "recoil";
import { commonPageAtom } from '../../../Recoil State/Atoms/AppAtoms';


const CommonPage = () => {

  const commonPageState = useRecoilValue(commonPageAtom);

  if(commonPageState)
  return (
    <div className='installation-page'>     
      <div className='bg-container'>
        <div className='content-container'>
          <CustomRouterComp/>                 
        </div>
        <div className='ig-logo'>
        </div>
      </div>
      
    </div>
  )
  else
  return(
    <CustomRouterComp />  
  )
  
}

export default React.memo(CommonPage);